import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TokenResponse } from '@openid/appauth';
import { concat, Observable, of, throwError } from 'rxjs';
import { concatMap, delay, first, retryWhen, switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CustomAuthService } from './custom-auth.service';
import { GlobalStateQuery } from '../state/global.appstate.query';

const retryCount = 5;
const retryWaitMilliSeconds = 500;
@Injectable()
export class TokenIncerceptor implements HttpInterceptor {
  constructor(private auth: CustomAuthService, private globalState: GlobalStateQuery) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const configs = this.auth.getAllEnvironmentConfigs();

    const anyConf = configs.some(config => (
      req.url.startsWith(config.fiwareUrl)
      || req.url.startsWith(config.timeSeriesDbUrl)
      || req.url.startsWith(config.inspireSSPUrl)));

    if (anyConf) {
      return this.auth.token.pipe(first(value => value != null),
        switchMap((token: TokenResponse) => {
          const authReq = req.clone({
            setHeaders: {
              Authorization: `${(token.tokenType === 'bearer') ? 'Bearer' : token.tokenType} ${token.accessToken}`
            }
          });
          return next.handle(authReq).pipe(
            retryWhen(error =>
              error.pipe(
                concatMap((error, count) => {
                  if (count <= retryCount && error.status == 401) {
                    return of(error);
                  }
                  return throwError(error);
                }),
                delay(retryWaitMilliSeconds))
            )
          );
        }));
    }



    return next.handle(req);

  }

}
